import React from 'react';

interface SortOptionModel {
  query: string;
  displayName: string;
  selected?: boolean;
}

interface SortOptionProps {
  option: SortOptionModel;
}

const SortOption = ({ option }: SortOptionProps) => (
  <option value={option.query}>Sortera på {option.displayName}</option>
);

interface SortOptionsProps {
  sortOptions?: SortOptionModel[];
  onApplySort: (value: string) => void;
}

const SortOptions = ({ sortOptions = [], onApplySort }: SortOptionsProps) => {
  const currentSort = sortOptions.find((so) => so.selected);

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => onApplySort(e.currentTarget.value);

  return (
    <div data-am-select="thin inline">
      <select className="select" value={currentSort?.query || ''} onChange={onChange}>
        {sortOptions.map((sortOption) => (
          <SortOption key={sortOption.query} option={sortOption} />
        ))}
      </select>
    </div>
  );
};

export default SortOptions;
